module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1040-81f7f76735066ed8961b18468deef832.png";